import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function ProtectedRoute({ role, children }) {
  const { user, hydrated } = useAuth();
  const location = useLocation();

  if (!hydrated) return null;

  if (!user) {
    const target = role === "driver" ? "/driver/login" : role === "admin" ? "/admin/login" : role === "wholesale" ? "/wholesale/login" : "/login";
    return <Navigate to={target} replace state={{ from: location.pathname }} />;
  }

  if (role && user.role !== role) {
    const home =
      user.role === "driver" ? "/driver/dashboard"
      : user.role === "admin" ? "/admin/dashboard"
      : user.role === "wholesale" ? "/wholesale/dashboard"
      : "/customer/dashboard";
    return <Navigate to={home} replace />;
  }

  return children;
}
